/**
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated by `Opus::GeneratedFileVerifier::Generators::DashboardData::DashboardDataCountriesStep`
 * If this file is out-of-sync or causing builds to fail, try running `scripts/bin/sync-generated`
 */ const countries = {
    "AD": {
        "alpha2": "AD",
        "alpha3": "AND",
        "currency": "eur",
        "name": "Andorra",
        "number": "020"
    },
    "AE": {
        "alpha2": "AE",
        "alpha3": "ARE",
        "currency": "aed",
        "name": "United Arab Emirates",
        "number": "784"
    },
    "AF": {
        "alpha2": "AF",
        "alpha3": "AFG",
        "currency": "afn",
        "name": "Afghanistan",
        "number": "004"
    },
    "AG": {
        "alpha2": "AG",
        "alpha3": "ATG",
        "currency": "xcd",
        "name": "Antigua and Barbuda",
        "number": "028"
    },
    "AI": {
        "alpha2": "AI",
        "alpha3": "AIA",
        "currency": "xcd",
        "name": "Anguilla",
        "number": "660"
    },
    "AL": {
        "alpha2": "AL",
        "alpha3": "ALB",
        "currency": "all",
        "name": "Albania",
        "number": "008"
    },
    "AM": {
        "alpha2": "AM",
        "alpha3": "ARM",
        "currency": "amd",
        "name": "Armenia",
        "number": "051"
    },
    "AO": {
        "alpha2": "AO",
        "alpha3": "AGO",
        "currency": "aoa",
        "name": "Angola",
        "number": "024"
    },
    "AQ": {
        "alpha2": "AQ",
        "alpha3": "ATA",
        "currency": "usd",
        "name": "Antarctica",
        "number": "010"
    },
    "AR": {
        "alpha2": "AR",
        "alpha3": "ARG",
        "currency": "ars",
        "name": "Argentina",
        "number": "032"
    },
    "AS": {
        "alpha2": "AS",
        "alpha3": "ASM",
        "currency": "usd",
        "name": "American Samoa",
        "number": "016"
    },
    "AT": {
        "alpha2": "AT",
        "alpha3": "AUT",
        "currency": "eur",
        "name": "Austria",
        "number": "040"
    },
    "AU": {
        "alpha2": "AU",
        "alpha3": "AUS",
        "currency": "aud",
        "name": "Australia",
        "number": "036",
        "states": {
            "ACT": {
                "name": "Australian Capital Territory"
            },
            "NSW": {
                "name": "New South Wales"
            },
            "NT": {
                "name": "Northern Territory"
            },
            "QLD": {
                "name": "Queensland"
            },
            "SA": {
                "name": "South Australia"
            },
            "TAS": {
                "name": "Tasmania"
            },
            "VIC": {
                "name": "Victoria"
            },
            "WA": {
                "name": "Western Australia"
            }
        }
    },
    "AW": {
        "alpha2": "AW",
        "alpha3": "ABW",
        "currency": "awg",
        "name": "Aruba",
        "number": "533"
    },
    "AX": {
        "alpha2": "AX",
        "alpha3": "ALA",
        "currency": "eur",
        "name": "Åland Islands",
        "number": "248"
    },
    "AZ": {
        "alpha2": "AZ",
        "alpha3": "AZE",
        "currency": "azn",
        "name": "Azerbaijan",
        "number": "031"
    },
    "BA": {
        "alpha2": "BA",
        "alpha3": "BIH",
        "currency": "bam",
        "name": "Bosnia and Herzegovina",
        "number": "070"
    },
    "BB": {
        "alpha2": "BB",
        "alpha3": "BRB",
        "currency": "bbd",
        "name": "Barbados",
        "number": "052"
    },
    "BD": {
        "alpha2": "BD",
        "alpha3": "BGD",
        "currency": "bdt",
        "name": "Bangladesh",
        "number": "050"
    },
    "BE": {
        "alpha2": "BE",
        "alpha3": "BEL",
        "currency": "eur",
        "name": "Belgium",
        "number": "056",
        "states": {
            "BRU": {
                "name": "Brussels"
            },
            "VAN": {
                "name": "Antwerpen (nl)"
            },
            "VBR": {
                "name": "Vlaams Brabant (nl)"
            },
            "VLI": {
                "name": "Limburg (nl)"
            },
            "VOV": {
                "name": "Oost-Vlaanderen (nl)"
            },
            "VWV": {
                "name": "West-Vlaanderen (nl)"
            },
            "WBR": {
                "name": "Brabant Wallon (fr)"
            },
            "WHT": {
                "name": "Hainaut (fr)"
            },
            "WLG": {
                "name": "Liège (fr)"
            },
            "WLX": {
                "name": "Luxembourg (fr)"
            },
            "WNA": {
                "name": "Namur (fr)"
            }
        }
    },
    "BF": {
        "alpha2": "BF",
        "alpha3": "BFA",
        "currency": "xof",
        "name": "Burkina Faso",
        "number": "854"
    },
    "BG": {
        "alpha2": "BG",
        "alpha3": "BGR",
        "currency": "bgn",
        "name": "Bulgaria",
        "number": "100"
    },
    "BH": {
        "alpha2": "BH",
        "alpha3": "BHR",
        "currency": "bhd",
        "name": "Bahrain",
        "number": "048"
    },
    "BI": {
        "alpha2": "BI",
        "alpha3": "BDI",
        "currency": "bif",
        "name": "Burundi",
        "number": "108"
    },
    "BJ": {
        "alpha2": "BJ",
        "alpha3": "BEN",
        "currency": "xof",
        "name": "Benin",
        "number": "204"
    },
    "BL": {
        "alpha2": "BL",
        "alpha3": "BLM",
        "currency": "eur",
        "name": "Saint Barthélemy",
        "number": "652"
    },
    "BM": {
        "alpha2": "BM",
        "alpha3": "BMU",
        "currency": "bmd",
        "name": "Bermuda",
        "number": "060"
    },
    "BN": {
        "alpha2": "BN",
        "alpha3": "BRN",
        "currency": "bnd",
        "name": "Brunei Darussalam",
        "number": "096"
    },
    "BO": {
        "alpha2": "BO",
        "alpha3": "BOL",
        "currency": "bob",
        "name": "Bolivia",
        "number": "068"
    },
    "BQ": {
        "alpha2": "BQ",
        "alpha3": "BES",
        "currency": "usd",
        "name": "Bonaire, Sint Eustatius and Saba",
        "number": "535"
    },
    "BR": {
        "alpha2": "BR",
        "alpha3": "BRA",
        "currency": "brl",
        "name": "Brazil",
        "number": "076",
        "states": {
            "AC": {
                "name": "Acre"
            },
            "AL": {
                "name": "Alagoas"
            },
            "AM": {
                "name": "Amazonas"
            },
            "AP": {
                "name": "Amapá"
            },
            "BA": {
                "name": "Bahia"
            },
            "CE": {
                "name": "Ceará"
            },
            "DF": {
                "name": "Distrito Federal"
            },
            "ES": {
                "name": "Espírito Santo"
            },
            "GO": {
                "name": "Goiás"
            },
            "MA": {
                "name": "Maranhão"
            },
            "MG": {
                "name": "Minas Gerais"
            },
            "MS": {
                "name": "Mato Grosso do Sul"
            },
            "MT": {
                "name": "Mato Grosso"
            },
            "PA": {
                "name": "Pará"
            },
            "PB": {
                "name": "Paraíba"
            },
            "PE": {
                "name": "Pernambuco"
            },
            "PI": {
                "name": "Piauí"
            },
            "PR": {
                "name": "Paraná"
            },
            "RJ": {
                "name": "Rio de Janeiro"
            },
            "RN": {
                "name": "Rio Grande do Norte"
            },
            "RO": {
                "name": "Rondônia"
            },
            "RR": {
                "name": "Roraima"
            },
            "RS": {
                "name": "Rio Grande do Sul"
            },
            "SC": {
                "name": "Santa Catarina"
            },
            "SE": {
                "name": "Sergipe"
            },
            "SP": {
                "name": "São Paulo"
            },
            "TO": {
                "name": "Tocantins"
            }
        }
    },
    "BS": {
        "alpha2": "BS",
        "alpha3": "BHS",
        "currency": "bsd",
        "name": "Bahamas",
        "number": "044"
    },
    "BT": {
        "alpha2": "BT",
        "alpha3": "BTN",
        "currency": "btn",
        "name": "Bhutan",
        "number": "064"
    },
    "BV": {
        "alpha2": "BV",
        "alpha3": "BVT",
        "currency": "nok",
        "name": "Bouvet Island",
        "number": "074"
    },
    "BW": {
        "alpha2": "BW",
        "alpha3": "BWA",
        "currency": "bwp",
        "name": "Botswana",
        "number": "072"
    },
    "BY": {
        "alpha2": "BY",
        "alpha3": "BLR",
        "currency": "byr",
        "name": "Belarus",
        "number": "112"
    },
    "BZ": {
        "alpha2": "BZ",
        "alpha3": "BLZ",
        "currency": "bzd",
        "name": "Belize",
        "number": "084"
    },
    "CA": {
        "alpha2": "CA",
        "alpha3": "CAN",
        "currency": "cad",
        "name": "Canada",
        "number": "124",
        "states": {
            "AB": {
                "name": "Alberta"
            },
            "BC": {
                "name": "British Columbia"
            },
            "MB": {
                "name": "Manitoba"
            },
            "NB": {
                "name": "New Brunswick"
            },
            "NL": {
                "name": "Newfoundland and Labrador"
            },
            "NS": {
                "name": "Nova Scotia"
            },
            "NT": {
                "name": "Northwest Territories"
            },
            "NU": {
                "name": "Nunavut"
            },
            "ON": {
                "name": "Ontario"
            },
            "PE": {
                "name": "Prince Edward Island"
            },
            "QC": {
                "name": "Quebec"
            },
            "SK": {
                "name": "Saskatchewan"
            },
            "YT": {
                "name": "Yukon Territory"
            }
        }
    },
    "CC": {
        "alpha2": "CC",
        "alpha3": "CCK",
        "currency": "aud",
        "name": "Cocos (Keeling) Islands",
        "number": "166"
    },
    "CD": {
        "alpha2": "CD",
        "alpha3": "COD",
        "currency": "cdf",
        "name": "Congo, The Democratic Republic Of The",
        "number": "180"
    },
    "CF": {
        "alpha2": "CF",
        "alpha3": "CAF",
        "currency": "xaf",
        "name": "Central African Republic",
        "number": "140"
    },
    "CG": {
        "alpha2": "CG",
        "alpha3": "COG",
        "currency": "xaf",
        "name": "Congo",
        "number": "178"
    },
    "CH": {
        "alpha2": "CH",
        "alpha3": "CHE",
        "currency": "chf",
        "name": "Switzerland",
        "number": "756"
    },
    "CI": {
        "alpha2": "CI",
        "alpha3": "CIV",
        "currency": "xof",
        "name": "Côte D'Ivoire",
        "number": "384"
    },
    "CK": {
        "alpha2": "CK",
        "alpha3": "COK",
        "currency": "nzd",
        "name": "Cook Islands",
        "number": "184"
    },
    "CL": {
        "alpha2": "CL",
        "alpha3": "CHL",
        "currency": "clp",
        "name": "Chile",
        "number": "152"
    },
    "CM": {
        "alpha2": "CM",
        "alpha3": "CMR",
        "currency": "xaf",
        "name": "Cameroon",
        "number": "120"
    },
    "CN": {
        "alpha2": "CN",
        "alpha3": "CHN",
        "currency": "cny",
        "name": "China",
        "number": "156"
    },
    "CO": {
        "alpha2": "CO",
        "alpha3": "COL",
        "currency": "cop",
        "name": "Colombia",
        "number": "170"
    },
    "CR": {
        "alpha2": "CR",
        "alpha3": "CRI",
        "currency": "crc",
        "name": "Costa Rica",
        "number": "188"
    },
    "CU": {
        "alpha2": "CU",
        "alpha3": "CUB",
        "currency": "cup",
        "name": "Cuba",
        "number": "192"
    },
    "CV": {
        "alpha2": "CV",
        "alpha3": "CPV",
        "currency": "cve",
        "name": "Cape Verde",
        "number": "132"
    },
    "CW": {
        "alpha2": "CW",
        "alpha3": "CUW",
        "currency": "xcg",
        "name": "Curaçao",
        "number": "531"
    },
    "CX": {
        "alpha2": "CX",
        "alpha3": "CXR",
        "currency": "aud",
        "name": "Christmas Island",
        "number": "162"
    },
    "CY": {
        "alpha2": "CY",
        "alpha3": "CYP",
        "currency": "eur",
        "name": "Cyprus",
        "number": "196"
    },
    "CZ": {
        "alpha2": "CZ",
        "alpha3": "CZE",
        "currency": "czk",
        "name": "Czech Republic",
        "number": "203"
    },
    "DE": {
        "alpha2": "DE",
        "alpha3": "DEU",
        "currency": "eur",
        "name": "Germany",
        "number": "276"
    },
    "DJ": {
        "alpha2": "DJ",
        "alpha3": "DJI",
        "currency": "djf",
        "name": "Djibouti",
        "number": "262"
    },
    "DK": {
        "alpha2": "DK",
        "alpha3": "DNK",
        "currency": "dkk",
        "name": "Denmark",
        "number": "208"
    },
    "DM": {
        "alpha2": "DM",
        "alpha3": "DMA",
        "currency": "xcd",
        "name": "Dominica",
        "number": "212"
    },
    "DO": {
        "alpha2": "DO",
        "alpha3": "DOM",
        "currency": "dop",
        "name": "Dominican Republic",
        "number": "214"
    },
    "DZ": {
        "alpha2": "DZ",
        "alpha3": "DZA",
        "currency": "dzd",
        "name": "Algeria",
        "number": "012"
    },
    "EC": {
        "alpha2": "EC",
        "alpha3": "ECU",
        "currency": "usd",
        "name": "Ecuador",
        "number": "218"
    },
    "EE": {
        "alpha2": "EE",
        "alpha3": "EST",
        "currency": "eur",
        "name": "Estonia",
        "number": "233"
    },
    "EG": {
        "alpha2": "EG",
        "alpha3": "EGY",
        "currency": "egp",
        "name": "Egypt",
        "number": "818"
    },
    "EH": {
        "alpha2": "EH",
        "alpha3": "ESH",
        "currency": "mad",
        "name": "Western Sahara",
        "number": "732"
    },
    "ER": {
        "alpha2": "ER",
        "alpha3": "ERI",
        "currency": "etb",
        "name": "Eritrea",
        "number": "232"
    },
    "ES": {
        "alpha2": "ES",
        "alpha3": "ESP",
        "currency": "eur",
        "name": "Spain",
        "number": "724",
        "states": {
            "A": {
                "name": "Alicante"
            },
            "AB": {
                "name": "Albacete"
            },
            "AL": {
                "name": "Almería"
            },
            "AV": {
                "name": "Ávila"
            },
            "B": {
                "name": "Barcelona"
            },
            "BA": {
                "name": "Badajoz"
            },
            "BI": {
                "name": "Vizcaya"
            },
            "BU": {
                "name": "Burgos"
            },
            "C": {
                "name": "A Coruña"
            },
            "CA": {
                "name": "Cádiz"
            },
            "CC": {
                "name": "Cáceres"
            },
            "CE": {
                "name": "Ceuta"
            },
            "CN": {
                "name": "Canary Islands"
            },
            "CO": {
                "name": "Córdoba"
            },
            "CR": {
                "name": "Ciudad Real"
            },
            "CS": {
                "name": "Castellón"
            },
            "CU": {
                "name": "Cuenca"
            },
            "GC": {
                "name": "Las Palmas"
            },
            "GI": {
                "name": "Girona"
            },
            "GR": {
                "name": "Granada"
            },
            "GU": {
                "name": "Guadalajara"
            },
            "H": {
                "name": "Huelva"
            },
            "HU": {
                "name": "Huesca"
            },
            "J": {
                "name": "Jaén"
            },
            "L": {
                "name": "Lleida"
            },
            "LE": {
                "name": "León"
            },
            "LO": {
                "name": "La Rioja"
            },
            "LU": {
                "name": "Lugo"
            },
            "M": {
                "name": "Madrid"
            },
            "MA": {
                "name": "Málaga"
            },
            "ML": {
                "name": "Melilla"
            },
            "MU": {
                "name": "Murcia"
            },
            "NA": {
                "name": "Navarra"
            },
            "O": {
                "name": "Asturias"
            },
            "OR": {
                "name": "Ourense"
            },
            "P": {
                "name": "Palencia"
            },
            "PM": {
                "name": "Baleares"
            },
            "PO": {
                "name": "Pontevedra"
            },
            "S": {
                "name": "Cantabria"
            },
            "SA": {
                "name": "Salamanca"
            },
            "SE": {
                "name": "Sevilla"
            },
            "SG": {
                "name": "Segovia"
            },
            "SO": {
                "name": "Soria"
            },
            "SS": {
                "name": "Guipúzcoa"
            },
            "T": {
                "name": "Tarragona"
            },
            "TE": {
                "name": "Teruel"
            },
            "TF": {
                "name": "Santa Cruz de Tenerife"
            },
            "TO": {
                "name": "Toledo"
            },
            "V": {
                "name": "Valencia"
            },
            "VA": {
                "name": "Valladolid"
            },
            "VI": {
                "name": "Álava"
            },
            "Z": {
                "name": "Zaragoza"
            },
            "ZA": {
                "name": "Zamora"
            }
        }
    },
    "ET": {
        "alpha2": "ET",
        "alpha3": "ETH",
        "currency": "etb",
        "name": "Ethiopia",
        "number": "231"
    },
    "FI": {
        "alpha2": "FI",
        "alpha3": "FIN",
        "currency": "eur",
        "name": "Finland",
        "number": "246"
    },
    "FJ": {
        "alpha2": "FJ",
        "alpha3": "FJI",
        "currency": "usd",
        "name": "Fiji",
        "number": "242"
    },
    "FK": {
        "alpha2": "FK",
        "alpha3": "FLK",
        "currency": "fkp",
        "name": "Falkland Islands (Malvinas)",
        "number": "238"
    },
    "FM": {
        "alpha2": "FM",
        "alpha3": "FSM",
        "currency": "usd",
        "name": "Micronesia, Federated States Of",
        "number": "583"
    },
    "FO": {
        "alpha2": "FO",
        "alpha3": "FRO",
        "currency": "dkk",
        "name": "Faroe Islands",
        "number": "234"
    },
    "FR": {
        "alpha2": "FR",
        "alpha3": "FRA",
        "currency": "eur",
        "name": "France",
        "number": "250",
        "states": {
            "01": {
                "name": "Ain"
            },
            "02": {
                "name": "Aisne"
            },
            "03": {
                "name": "Allier"
            },
            "04": {
                "name": "Alpes-de-Haute-Provence"
            },
            "05": {
                "name": "Hautes-Alpes"
            },
            "06": {
                "name": "Alpes-Maritimes"
            },
            "07": {
                "name": "Ardèche"
            },
            "08": {
                "name": "Ardennes"
            },
            "09": {
                "name": "Ariège"
            },
            "10": {
                "name": "Aube"
            },
            "11": {
                "name": "Aude"
            },
            "12": {
                "name": "Aveyron"
            },
            "13": {
                "name": "Bouches-du-Rhône"
            },
            "14": {
                "name": "Calvados"
            },
            "15": {
                "name": "Cantal"
            },
            "16": {
                "name": "Charente"
            },
            "17": {
                "name": "Charente-Maritime"
            },
            "18": {
                "name": "Cher"
            },
            "19": {
                "name": "Corrèze"
            },
            "21": {
                "name": "Côte-d'Or"
            },
            "22": {
                "name": "Côtes-d'Armor"
            },
            "23": {
                "name": "Creuse"
            },
            "24": {
                "name": "Dordogne"
            },
            "25": {
                "name": "Doubs"
            },
            "26": {
                "name": "Drôme"
            },
            "27": {
                "name": "Eure"
            },
            "28": {
                "name": "Eure-et-Loir"
            },
            "29": {
                "name": "Finistère"
            },
            "2A": {
                "name": "Corse-du-Sud"
            },
            "2B": {
                "name": "Haute-Corse"
            },
            "30": {
                "name": "Gard"
            },
            "31": {
                "name": "Haute-Garonne"
            },
            "32": {
                "name": "Gers"
            },
            "33": {
                "name": "Gironde"
            },
            "34": {
                "name": "Hérault"
            },
            "35": {
                "name": "Ille-et-Vilaine"
            },
            "36": {
                "name": "Indre"
            },
            "37": {
                "name": "Indre-et-Loire"
            },
            "38": {
                "name": "Isère"
            },
            "39": {
                "name": "Jura"
            },
            "40": {
                "name": "Landes"
            },
            "41": {
                "name": "Loir-et-Cher"
            },
            "42": {
                "name": "Loire"
            },
            "43": {
                "name": "Haute-Loire"
            },
            "44": {
                "name": "Loire-Atlantique"
            },
            "45": {
                "name": "Loiret"
            },
            "46": {
                "name": "Lot"
            },
            "47": {
                "name": "Lot-et-Garonne"
            },
            "48": {
                "name": "Lozère"
            },
            "49": {
                "name": "Maine-et-Loire"
            },
            "50": {
                "name": "Manche"
            },
            "51": {
                "name": "Marne"
            },
            "52": {
                "name": "Haute-Marne"
            },
            "53": {
                "name": "Mayenne"
            },
            "54": {
                "name": "Meurthe-et-Moselle"
            },
            "55": {
                "name": "Meuse"
            },
            "56": {
                "name": "Morbihan"
            },
            "57": {
                "name": "Moselle"
            },
            "58": {
                "name": "Nièvre"
            },
            "59": {
                "name": "Nord"
            },
            "60": {
                "name": "Oise"
            },
            "61": {
                "name": "Orne"
            },
            "62": {
                "name": "Pas-de-Calais"
            },
            "63": {
                "name": "Puy-de-Dôme"
            },
            "64": {
                "name": "Pyrénées-Atlantiques"
            },
            "65": {
                "name": "Hautes-Pyrénées"
            },
            "66": {
                "name": "Pyrénées-Orientales"
            },
            "67": {
                "name": "Bas-Rhin"
            },
            "68": {
                "name": "Haut-Rhin"
            },
            "69": {
                "name": "Rhône"
            },
            "70": {
                "name": "Haute-Saône"
            },
            "71": {
                "name": "Saône-et-Loire"
            },
            "72": {
                "name": "Sarthe"
            },
            "73": {
                "name": "Savoie"
            },
            "74": {
                "name": "Haute-Savoie"
            },
            "75": {
                "name": "Paris"
            },
            "76": {
                "name": "Seine-Maritime"
            },
            "77": {
                "name": "Seine-et-Marne"
            },
            "78": {
                "name": "Yvelines"
            },
            "79": {
                "name": "Deux-Sèvres"
            },
            "80": {
                "name": "Somme"
            },
            "81": {
                "name": "Tarn"
            },
            "82": {
                "name": "Tarn-et-Garonne"
            },
            "83": {
                "name": "Var"
            },
            "84": {
                "name": "Vaucluse"
            },
            "85": {
                "name": "Vendée"
            },
            "86": {
                "name": "Vienne"
            },
            "87": {
                "name": "Haute-Vienne"
            },
            "88": {
                "name": "Vosges"
            },
            "89": {
                "name": "Yonne"
            },
            "90": {
                "name": "Territoire de Belfort"
            },
            "91": {
                "name": "Essonne"
            },
            "92": {
                "name": "Hauts-de-Seine"
            },
            "93": {
                "name": "Seine-Saint-Denis"
            },
            "94": {
                "name": "Val-de-Marne"
            },
            "95": {
                "name": "Val-d'Oise"
            },
            "NC": {
                "name": "Nouvelle-Calédonie"
            },
            "PF": {
                "name": "Polynésie française"
            },
            "PM": {
                "name": "Saint-Pierre-et-Miquelon"
            },
            "TF": {
                "name": "Terres Australes Françaises"
            },
            "WF": {
                "name": "Wallis et Futuna"
            },
            "YT": {
                "name": "Mayotte"
            }
        }
    },
    "GA": {
        "alpha2": "GA",
        "alpha3": "GAB",
        "currency": "xaf",
        "name": "Gabon",
        "number": "266"
    },
    "GB": {
        "alpha2": "GB",
        "alpha3": "GBR",
        "currency": "gbp",
        "name": "United Kingdom",
        "number": "826"
    },
    "GD": {
        "alpha2": "GD",
        "alpha3": "GRD",
        "currency": "xcd",
        "name": "Grenada",
        "number": "308"
    },
    "GE": {
        "alpha2": "GE",
        "alpha3": "GEO",
        "currency": "gel",
        "name": "Georgia",
        "number": "268"
    },
    "GF": {
        "alpha2": "GF",
        "alpha3": "GUF",
        "currency": "eur",
        "name": "French Guiana",
        "number": "254"
    },
    "GG": {
        "alpha2": "GG",
        "alpha3": "GGY",
        "currency": "ggp",
        "name": "Guernsey",
        "number": "831"
    },
    "GH": {
        "alpha2": "GH",
        "alpha3": "GHA",
        "currency": "ghs",
        "name": "Ghana",
        "number": "288"
    },
    "GI": {
        "alpha2": "GI",
        "alpha3": "GIB",
        "currency": "gip",
        "name": "Gibraltar",
        "number": "292"
    },
    "GL": {
        "alpha2": "GL",
        "alpha3": "GRL",
        "currency": "dkk",
        "name": "Greenland",
        "number": "304"
    },
    "GM": {
        "alpha2": "GM",
        "alpha3": "GMB",
        "currency": "gmd",
        "name": "Gambia",
        "number": "270"
    },
    "GN": {
        "alpha2": "GN",
        "alpha3": "GIN",
        "currency": "gnf",
        "name": "Guinea",
        "number": "324"
    },
    "GP": {
        "alpha2": "GP",
        "alpha3": "GLP",
        "currency": "eur",
        "name": "Guadeloupe",
        "number": "312"
    },
    "GQ": {
        "alpha2": "GQ",
        "alpha3": "GNQ",
        "currency": "xaf",
        "name": "Equatorial Guinea",
        "number": "226"
    },
    "GR": {
        "alpha2": "GR",
        "alpha3": "GRC",
        "currency": "eur",
        "name": "Greece",
        "number": "300"
    },
    "GS": {
        "alpha2": "GS",
        "alpha3": "SGS",
        "currency": "gbp",
        "name": "South Georgia and the South Sandwich Islands",
        "number": "239"
    },
    "GT": {
        "alpha2": "GT",
        "alpha3": "GTM",
        "currency": "gtq",
        "name": "Guatemala",
        "number": "320"
    },
    "GU": {
        "alpha2": "GU",
        "alpha3": "GUM",
        "currency": "usd",
        "name": "Guam",
        "number": "316"
    },
    "GW": {
        "alpha2": "GW",
        "alpha3": "GNB",
        "currency": "xof",
        "name": "Guinea-Bissau",
        "number": "624"
    },
    "GY": {
        "alpha2": "GY",
        "alpha3": "GUY",
        "currency": "gyd",
        "name": "Guyana",
        "number": "328"
    },
    "HK": {
        "alpha2": "HK",
        "alpha3": "HKG",
        "currency": "hkd",
        "name": "Hong Kong",
        "number": "344",
        "states": {
            "Hong Kong": {
                "name": "Hong Kong"
            },
            "Kowloon": {
                "name": "Kowloon"
            },
            "New Territories": {
                "name": "New Territories"
            }
        }
    },
    "HM": {
        "alpha2": "HM",
        "alpha3": "HMD",
        "currency": "aud",
        "name": "Heard and McDonald Islands",
        "number": "334"
    },
    "HN": {
        "alpha2": "HN",
        "alpha3": "HND",
        "currency": "hnl",
        "name": "Honduras",
        "number": "340"
    },
    "HR": {
        "alpha2": "HR",
        "alpha3": "HRV",
        "currency": "eur",
        "name": "Croatia",
        "number": "191"
    },
    "HT": {
        "alpha2": "HT",
        "alpha3": "HTI",
        "currency": "usd",
        "name": "Haiti",
        "number": "332"
    },
    "HU": {
        "alpha2": "HU",
        "alpha3": "HUN",
        "currency": "huf",
        "name": "Hungary",
        "number": "348"
    },
    "ID": {
        "alpha2": "ID",
        "alpha3": "IDN",
        "currency": "idr",
        "name": "Indonesia",
        "number": "360"
    },
    "IE": {
        "alpha2": "IE",
        "alpha3": "IRL",
        "currency": "eur",
        "name": "Ireland",
        "number": "372",
        "states": {
            "C": {
                "name": "Cork"
            },
            "CE": {
                "name": "Clare"
            },
            "CN": {
                "name": "Cavan"
            },
            "CW": {
                "name": "Carlow"
            },
            "D": {
                "name": "Dublin"
            },
            "DL": {
                "name": "Donegal"
            },
            "G": {
                "name": "Galway"
            },
            "KE": {
                "name": "Kildare"
            },
            "KK": {
                "name": "Kilkenny"
            },
            "KY": {
                "name": "Kerry"
            },
            "LD": {
                "name": "Longford"
            },
            "LH": {
                "name": "Louth"
            },
            "LK": {
                "name": "Limerick"
            },
            "LM": {
                "name": "Leitrim"
            },
            "LS": {
                "name": "Laois"
            },
            "MH": {
                "name": "Meath"
            },
            "MN": {
                "name": "Monaghan"
            },
            "MO": {
                "name": "Mayo"
            },
            "OY": {
                "name": "Offaly"
            },
            "RN": {
                "name": "Roscommon"
            },
            "SO": {
                "name": "Sligo"
            },
            "TA": {
                "name": "Tipperary"
            },
            "WD": {
                "name": "Waterford"
            },
            "WH": {
                "name": "Westmeath"
            },
            "WW": {
                "name": "Wicklow"
            },
            "WX": {
                "name": "Wexford"
            }
        }
    },
    "IL": {
        "alpha2": "IL",
        "alpha3": "ISR",
        "currency": "ils",
        "name": "Israel",
        "number": "376"
    },
    "IM": {
        "alpha2": "IM",
        "alpha3": "IMN",
        "currency": "imp",
        "name": "Isle of Man",
        "number": "833"
    },
    "IN": {
        "alpha2": "IN",
        "alpha3": "IND",
        "currency": "inr",
        "name": "India",
        "number": "356",
        "states": {
            "AN": {
                "name": "Andaman and Nicobar Islands"
            },
            "AP": {
                "name": "Andhra Pradesh"
            },
            "AR": {
                "name": "Arunachal Pradesh"
            },
            "AS": {
                "name": "Assam"
            },
            "BR": {
                "name": "Bihar"
            },
            "CH": {
                "name": "Chandigarh"
            },
            "CT": {
                "name": "Chhattisgarh"
            },
            "DD": {
                "name": "Daman and Diu"
            },
            "DL": {
                "name": "Delhi"
            },
            "DN": {
                "name": "Dadra and Nagar Haveli"
            },
            "GA": {
                "name": "Goa"
            },
            "GJ": {
                "name": "Gujarat"
            },
            "HP": {
                "name": "Himachal Pradesh"
            },
            "HR": {
                "name": "Haryana"
            },
            "JH": {
                "name": "Jharkhand"
            },
            "JK": {
                "name": "Jammu and Kashmir"
            },
            "KA": {
                "name": "Karnataka"
            },
            "KL": {
                "name": "Kerala"
            },
            "LD": {
                "name": "Lakshadweep"
            },
            "MH": {
                "name": "Maharashtra"
            },
            "ML": {
                "name": "Meghalaya"
            },
            "MN": {
                "name": "Manipur"
            },
            "MP": {
                "name": "Madhya Pradesh"
            },
            "MZ": {
                "name": "Mizoram"
            },
            "NL": {
                "name": "Nagaland"
            },
            "OR": {
                "name": "Orissa"
            },
            "PB": {
                "name": "Punjab"
            },
            "PY": {
                "name": "Pondicherry"
            },
            "RJ": {
                "name": "Rajasthan"
            },
            "SK": {
                "name": "Sikkim"
            },
            "TG": {
                "name": "Telangana"
            },
            "TN": {
                "name": "Tamil Nadu"
            },
            "TR": {
                "name": "Tripura"
            },
            "UL": {
                "name": "Uttaranchal"
            },
            "UP": {
                "name": "Uttar Pradesh"
            },
            "WB": {
                "name": "West Bengal"
            },
            "DH": {
                "name": "Dadra and Nagar Haveli and Daman and Diu"
            },
            "LA": {
                "name": "Ladakh"
            },
            "UT": {
                "name": "Uttarakhand"
            }
        }
    },
    "IO": {
        "alpha2": "IO",
        "alpha3": "IOT",
        "currency": "usd",
        "name": "British Indian Ocean Territory",
        "number": "086"
    },
    "IQ": {
        "alpha2": "IQ",
        "alpha3": "IRQ",
        "currency": "iqd",
        "name": "Iraq",
        "number": "368"
    },
    "IR": {
        "alpha2": "IR",
        "alpha3": "IRN",
        "currency": "irr",
        "name": "Iran, Islamic Republic Of",
        "number": "364"
    },
    "IS": {
        "alpha2": "IS",
        "alpha3": "ISL",
        "currency": "isk",
        "name": "Iceland",
        "number": "352"
    },
    "IT": {
        "alpha2": "IT",
        "alpha3": "ITA",
        "currency": "eur",
        "name": "Italy",
        "number": "380",
        "states": {
            "AG": {
                "name": "Agrigento"
            },
            "AL": {
                "name": "Alessandria"
            },
            "AN": {
                "name": "Ancona"
            },
            "AO": {
                "name": "Aosta"
            },
            "AP": {
                "name": "Ascoli Piceno"
            },
            "AQ": {
                "name": "L'Aquila"
            },
            "AR": {
                "name": "Arezzo"
            },
            "AT": {
                "name": "Asti"
            },
            "AV": {
                "name": "Avellino"
            },
            "BA": {
                "name": "Bari"
            },
            "BG": {
                "name": "Bergamo"
            },
            "BI": {
                "name": "Biella"
            },
            "BL": {
                "name": "Belluno"
            },
            "BN": {
                "name": "Benevento"
            },
            "BO": {
                "name": "Bologna"
            },
            "BR": {
                "name": "Brindisi"
            },
            "BS": {
                "name": "Brescia"
            },
            "BT": {
                "name": "Barletta-Andria-Trani"
            },
            "BZ": {
                "name": "Bolzano"
            },
            "CA": {
                "name": "Cagliari"
            },
            "CB": {
                "name": "Campobasso"
            },
            "CE": {
                "name": "Caserta"
            },
            "CH": {
                "name": "Chieti"
            },
            "CI": {
                "name": "Carbonia-Iglesias"
            },
            "CL": {
                "name": "Caltanissetta"
            },
            "CN": {
                "name": "Cuneo"
            },
            "CO": {
                "name": "Como"
            },
            "CR": {
                "name": "Cremona"
            },
            "CS": {
                "name": "Cosenza"
            },
            "CT": {
                "name": "Catania"
            },
            "CZ": {
                "name": "Catanzaro"
            },
            "EN": {
                "name": "Enna"
            },
            "FC": {
                "name": "Forlì-Cesena"
            },
            "FE": {
                "name": "Ferrara"
            },
            "FG": {
                "name": "Foggia"
            },
            "FI": {
                "name": "Firenze"
            },
            "FM": {
                "name": "Fermo"
            },
            "FR": {
                "name": "Frosinone "
            },
            "GE": {
                "name": "Genova"
            },
            "GO": {
                "name": "Gorizia"
            },
            "GR": {
                "name": "Grosseto"
            },
            "IM": {
                "name": "Imperia"
            },
            "IS": {
                "name": "Isernia"
            },
            "KR": {
                "name": "Crotone"
            },
            "LC": {
                "name": "Lecco"
            },
            "LE": {
                "name": "Lecce"
            },
            "LI": {
                "name": "Livorno"
            },
            "LO": {
                "name": "Lodi"
            },
            "LT": {
                "name": "Latina"
            },
            "LU": {
                "name": "Lucca"
            },
            "MB": {
                "name": "Monza e Brianza"
            },
            "MC": {
                "name": "Macerata"
            },
            "ME": {
                "name": "Messina"
            },
            "MI": {
                "name": "Milano"
            },
            "MN": {
                "name": "Mantova"
            },
            "MO": {
                "name": "Modena"
            },
            "MS": {
                "name": "Massa-Carrara"
            },
            "MT": {
                "name": "Matera"
            },
            "NA": {
                "name": "Napoli"
            },
            "NO": {
                "name": "Novara"
            },
            "NU": {
                "name": "Nuoro"
            },
            "OG": {
                "name": "Ogliastra"
            },
            "OR": {
                "name": "Oristano"
            },
            "OT": {
                "name": "Olbia-Tempio"
            },
            "PA": {
                "name": "Palermo"
            },
            "PC": {
                "name": "Piacenza"
            },
            "PD": {
                "name": "Padova"
            },
            "PE": {
                "name": "Pescara"
            },
            "PG": {
                "name": "Perugia"
            },
            "PI": {
                "name": "Pisa"
            },
            "PN": {
                "name": "Pordenone"
            },
            "PO": {
                "name": "Prato"
            },
            "PR": {
                "name": "Parma"
            },
            "PT": {
                "name": "Pistoia"
            },
            "PU": {
                "name": "Pesaro e Urbino"
            },
            "PV": {
                "name": "Pavia"
            },
            "PZ": {
                "name": "Potenza"
            },
            "RA": {
                "name": "Ravenna"
            },
            "RC": {
                "name": "Reggio Calabria"
            },
            "RE": {
                "name": "Reggio Emilia"
            },
            "RG": {
                "name": "Ragusa"
            },
            "RI": {
                "name": "Rieti"
            },
            "RM": {
                "name": "Roma"
            },
            "RN": {
                "name": "Rimini"
            },
            "RO": {
                "name": "Rovigo"
            },
            "SA": {
                "name": "Salerno"
            },
            "SI": {
                "name": "Siena"
            },
            "SO": {
                "name": "Sondrio"
            },
            "SP": {
                "name": "La Spezia"
            },
            "SR": {
                "name": "Siracusa"
            },
            "SS": {
                "name": "Sassari"
            },
            "SU": {
                "name": "Sud Sardegna"
            },
            "SV": {
                "name": "Savona"
            },
            "TA": {
                "name": "Taranto"
            },
            "TE": {
                "name": "Teramo"
            },
            "TN": {
                "name": "Trento"
            },
            "TO": {
                "name": "Torino"
            },
            "TP": {
                "name": "Trapani"
            },
            "TR": {
                "name": "Terni"
            },
            "TS": {
                "name": "Trieste"
            },
            "TV": {
                "name": "Treviso"
            },
            "UD": {
                "name": "Udine"
            },
            "VA": {
                "name": "Varese"
            },
            "VB": {
                "name": "Verbano-Cusio-Ossola"
            },
            "VC": {
                "name": "Vercelli"
            },
            "VE": {
                "name": "Venezia"
            },
            "VI": {
                "name": "Vicenza"
            },
            "VR": {
                "name": "Verona"
            },
            "VS": {
                "name": "Medio Campidano"
            },
            "VT": {
                "name": "Viterbo"
            },
            "VV": {
                "name": "Vibo Valentia"
            }
        }
    },
    "JE": {
        "alpha2": "JE",
        "alpha3": "JEY",
        "currency": "jep",
        "name": "Jersey",
        "number": "832"
    },
    "JM": {
        "alpha2": "JM",
        "alpha3": "JAM",
        "currency": "jmd",
        "name": "Jamaica",
        "number": "388"
    },
    "JO": {
        "alpha2": "JO",
        "alpha3": "JOR",
        "currency": "jod",
        "name": "Jordan",
        "number": "400"
    },
    "JP": {
        "alpha2": "JP",
        "alpha3": "JPN",
        "currency": "jpy",
        "name": "Japan",
        "number": "392"
    },
    "KE": {
        "alpha2": "KE",
        "alpha3": "KEN",
        "currency": "kes",
        "name": "Kenya",
        "number": "404"
    },
    "KG": {
        "alpha2": "KG",
        "alpha3": "KGZ",
        "currency": "kgs",
        "name": "Kyrgyzstan",
        "number": "417"
    },
    "KH": {
        "alpha2": "KH",
        "alpha3": "KHM",
        "currency": "khr",
        "name": "Cambodia",
        "number": "116"
    },
    "KI": {
        "alpha2": "KI",
        "alpha3": "KIR",
        "currency": "aud",
        "name": "Kiribati",
        "number": "296"
    },
    "KM": {
        "alpha2": "KM",
        "alpha3": "COM",
        "currency": "kmf",
        "name": "Comoros",
        "number": "174"
    },
    "KN": {
        "alpha2": "KN",
        "alpha3": "KNA",
        "currency": "xcd",
        "name": "Saint Kitts And Nevis",
        "number": "659"
    },
    "KP": {
        "alpha2": "KP",
        "alpha3": "PRK",
        "currency": "kpw",
        "name": "Korea, Democratic People's Republic Of",
        "number": "408"
    },
    "KR": {
        "alpha2": "KR",
        "alpha3": "KOR",
        "currency": "krw",
        "name": "Korea, Republic of",
        "number": "410"
    },
    "KW": {
        "alpha2": "KW",
        "alpha3": "KWT",
        "currency": "kwd",
        "name": "Kuwait",
        "number": "414"
    },
    "KY": {
        "alpha2": "KY",
        "alpha3": "CYM",
        "currency": "kyd",
        "name": "Cayman Islands",
        "number": "136"
    },
    "KZ": {
        "alpha2": "KZ",
        "alpha3": "KAZ",
        "currency": "kzt",
        "name": "Kazakhstan",
        "number": "398"
    },
    "LA": {
        "alpha2": "LA",
        "alpha3": "LAO",
        "currency": "lak",
        "name": "Lao People's Democratic Republic",
        "number": "418"
    },
    "LB": {
        "alpha2": "LB",
        "alpha3": "LBN",
        "currency": "lbp",
        "name": "Lebanon",
        "number": "422"
    },
    "LC": {
        "alpha2": "LC",
        "alpha3": "LCA",
        "currency": "xcd",
        "name": "Saint Lucia",
        "number": "662"
    },
    "LI": {
        "alpha2": "LI",
        "alpha3": "LIE",
        "currency": "chf",
        "name": "Liechtenstein",
        "number": "438"
    },
    "LK": {
        "alpha2": "LK",
        "alpha3": "LKA",
        "currency": "lkr",
        "name": "Sri Lanka",
        "number": "144"
    },
    "LR": {
        "alpha2": "LR",
        "alpha3": "LBR",
        "currency": "lrd",
        "name": "Liberia",
        "number": "430"
    },
    "LS": {
        "alpha2": "LS",
        "alpha3": "LSO",
        "currency": "lsl",
        "name": "Lesotho",
        "number": "426"
    },
    "LT": {
        "alpha2": "LT",
        "alpha3": "LTU",
        "currency": "eur",
        "name": "Lithuania",
        "number": "440"
    },
    "LU": {
        "alpha2": "LU",
        "alpha3": "LUX",
        "currency": "eur",
        "name": "Luxembourg",
        "number": "442"
    },
    "LV": {
        "alpha2": "LV",
        "alpha3": "LVA",
        "currency": "eur",
        "name": "Latvia",
        "number": "428"
    },
    "LY": {
        "alpha2": "LY",
        "alpha3": "LBY",
        "currency": "lyd",
        "name": "Libya",
        "number": "434"
    },
    "MA": {
        "alpha2": "MA",
        "alpha3": "MAR",
        "currency": "mad",
        "name": "Morocco",
        "number": "504"
    },
    "MC": {
        "alpha2": "MC",
        "alpha3": "MCO",
        "currency": "eur",
        "name": "Monaco",
        "number": "492"
    },
    "MD": {
        "alpha2": "MD",
        "alpha3": "MDA",
        "currency": "mdl",
        "name": "Moldova, Republic of",
        "number": "498"
    },
    "ME": {
        "alpha2": "ME",
        "alpha3": "MNE",
        "currency": "eur",
        "name": "Montenegro",
        "number": "499"
    },
    "MF": {
        "alpha2": "MF",
        "alpha3": "MAF",
        "currency": "eur",
        "name": "Saint Martin",
        "number": "663"
    },
    "MG": {
        "alpha2": "MG",
        "alpha3": "MDG",
        "currency": "mga",
        "name": "Madagascar",
        "number": "450"
    },
    "MH": {
        "alpha2": "MH",
        "alpha3": "MHL",
        "currency": "usd",
        "name": "Marshall Islands",
        "number": "584"
    },
    "MK": {
        "alpha2": "MK",
        "alpha3": "MKD",
        "currency": "mkd",
        "name": "North Macedonia",
        "number": "807"
    },
    "ML": {
        "alpha2": "ML",
        "alpha3": "MLI",
        "currency": "xof",
        "name": "Mali",
        "number": "466"
    },
    "MM": {
        "alpha2": "MM",
        "alpha3": "MMR",
        "currency": "mmk",
        "name": "Myanmar",
        "number": "104"
    },
    "MN": {
        "alpha2": "MN",
        "alpha3": "MNG",
        "currency": "mnt",
        "name": "Mongolia",
        "number": "496"
    },
    "MO": {
        "alpha2": "MO",
        "alpha3": "MAC",
        "currency": "mop",
        "name": "Macau",
        "number": "446"
    },
    "MP": {
        "alpha2": "MP",
        "alpha3": "MNP",
        "currency": "usd",
        "name": "Northern Mariana Islands",
        "number": "580"
    },
    "MQ": {
        "alpha2": "MQ",
        "alpha3": "MTQ",
        "currency": "eur",
        "name": "Martinique",
        "number": "474"
    },
    "MR": {
        "alpha2": "MR",
        "alpha3": "MRT",
        "currency": "mro",
        "name": "Mauritania",
        "number": "478"
    },
    "MS": {
        "alpha2": "MS",
        "alpha3": "MSR",
        "currency": "xcd",
        "name": "Montserrat",
        "number": "500"
    },
    "MT": {
        "alpha2": "MT",
        "alpha3": "MLT",
        "currency": "eur",
        "name": "Malta",
        "number": "470"
    },
    "MU": {
        "alpha2": "MU",
        "alpha3": "MUS",
        "currency": "mur",
        "name": "Mauritius",
        "number": "480"
    },
    "MV": {
        "alpha2": "MV",
        "alpha3": "MDV",
        "currency": "mvr",
        "name": "Maldives",
        "number": "462"
    },
    "MW": {
        "alpha2": "MW",
        "alpha3": "MWI",
        "currency": "mwk",
        "name": "Malawi",
        "number": "454"
    },
    "MX": {
        "alpha2": "MX",
        "alpha3": "MEX",
        "currency": "mxn",
        "name": "Mexico",
        "number": "484",
        "states": {
            "AGU": {
                "name": "Aguascalientes"
            },
            "BCN": {
                "name": "Baja California"
            },
            "BCS": {
                "name": "Baja California Sur"
            },
            "CAM": {
                "name": "Campeche"
            },
            "CHH": {
                "name": "Chihuahua"
            },
            "CHP": {
                "name": "Chiapas"
            },
            "CMX": {
                "name": "Ciudad de México"
            },
            "COA": {
                "name": "Coahuila"
            },
            "COL": {
                "name": "Colima"
            },
            "DUR": {
                "name": "Durango"
            },
            "GRO": {
                "name": "Guerrero"
            },
            "GUA": {
                "name": "Guanajuato"
            },
            "HID": {
                "name": "Hidalgo"
            },
            "JAL": {
                "name": "Jalisco"
            },
            "MEX": {
                "name": "México"
            },
            "MIC": {
                "name": "Michoacán"
            },
            "MOR": {
                "name": "Morelos"
            },
            "NAY": {
                "name": "Nayarit"
            },
            "NLE": {
                "name": "Nuevo León"
            },
            "OAX": {
                "name": "Oaxaca"
            },
            "PUE": {
                "name": "Puebla"
            },
            "QUE": {
                "name": "Querétaro"
            },
            "ROO": {
                "name": "Quintana Roo"
            },
            "SIN": {
                "name": "Sinaloa"
            },
            "SLP": {
                "name": "San Luis Potosí"
            },
            "SON": {
                "name": "Sonora"
            },
            "TAB": {
                "name": "Tabasco"
            },
            "TAM": {
                "name": "Tamaulipas"
            },
            "TLA": {
                "name": "Tlaxcala"
            },
            "VER": {
                "name": "Veracruz"
            },
            "YUC": {
                "name": "Yucatán"
            },
            "ZAC": {
                "name": "Zacatecas"
            }
        }
    },
    "MY": {
        "alpha2": "MY",
        "alpha3": "MYS",
        "currency": "myr",
        "name": "Malaysia",
        "number": "458"
    },
    "MZ": {
        "alpha2": "MZ",
        "alpha3": "MOZ",
        "currency": "mzn",
        "name": "Mozambique",
        "number": "508"
    },
    "NA": {
        "alpha2": "NA",
        "alpha3": "NAM",
        "currency": "nad",
        "name": "Namibia",
        "number": "516"
    },
    "NC": {
        "alpha2": "NC",
        "alpha3": "NCL",
        "currency": "xpf",
        "name": "New Caledonia",
        "number": "540"
    },
    "NE": {
        "alpha2": "NE",
        "alpha3": "NER",
        "currency": "xof",
        "name": "Niger",
        "number": "562"
    },
    "NF": {
        "alpha2": "NF",
        "alpha3": "NFK",
        "currency": "aud",
        "name": "Norfolk Island",
        "number": "574"
    },
    "NG": {
        "alpha2": "NG",
        "alpha3": "NGA",
        "currency": "ngn",
        "name": "Nigeria",
        "number": "566"
    },
    "NI": {
        "alpha2": "NI",
        "alpha3": "NIC",
        "currency": "nio",
        "name": "Nicaragua",
        "number": "558"
    },
    "NL": {
        "alpha2": "NL",
        "alpha3": "NLD",
        "currency": "eur",
        "name": "Netherlands",
        "number": "528",
        "states": {
            "DR": {
                "name": "Drenthe"
            },
            "FL": {
                "name": "Flevoland"
            },
            "FR": {
                "name": "Friesland"
            },
            "GE": {
                "name": "Gelderland"
            },
            "GR": {
                "name": "Groningen"
            },
            "LI": {
                "name": "Limburg"
            },
            "NB": {
                "name": "Noord-Brabant"
            },
            "NH": {
                "name": "Noord-Holland"
            },
            "OV": {
                "name": "Overijssel"
            },
            "UT": {
                "name": "Utrecht"
            },
            "ZE": {
                "name": "Zeeland"
            },
            "ZH": {
                "name": "Zuid-Holland"
            }
        }
    },
    "NO": {
        "alpha2": "NO",
        "alpha3": "NOR",
        "currency": "nok",
        "name": "Norway",
        "number": "578"
    },
    "NP": {
        "alpha2": "NP",
        "alpha3": "NPL",
        "currency": "npr",
        "name": "Nepal",
        "number": "524"
    },
    "NR": {
        "alpha2": "NR",
        "alpha3": "NRU",
        "currency": "aud",
        "name": "Nauru",
        "number": "520"
    },
    "NU": {
        "alpha2": "NU",
        "alpha3": "NIU",
        "currency": "nzd",
        "name": "Niue",
        "number": "570"
    },
    "NZ": {
        "alpha2": "NZ",
        "alpha3": "NZL",
        "currency": "nzd",
        "name": "New Zealand",
        "number": "554"
    },
    "OM": {
        "alpha2": "OM",
        "alpha3": "OMN",
        "currency": "omr",
        "name": "Oman",
        "number": "512"
    },
    "PA": {
        "alpha2": "PA",
        "alpha3": "PAN",
        "currency": "pab",
        "name": "Panama",
        "number": "591"
    },
    "PE": {
        "alpha2": "PE",
        "alpha3": "PER",
        "currency": "pen",
        "name": "Peru",
        "number": "604"
    },
    "PF": {
        "alpha2": "PF",
        "alpha3": "PYF",
        "currency": "xpf",
        "name": "French Polynesia",
        "number": "258"
    },
    "PG": {
        "alpha2": "PG",
        "alpha3": "PNG",
        "currency": "pgk",
        "name": "Papua New Guinea",
        "number": "598"
    },
    "PH": {
        "alpha2": "PH",
        "alpha3": "PHL",
        "currency": "php",
        "name": "Philippines",
        "number": "608"
    },
    "PK": {
        "alpha2": "PK",
        "alpha3": "PAK",
        "currency": "pkr",
        "name": "Pakistan",
        "number": "586"
    },
    "PL": {
        "alpha2": "PL",
        "alpha3": "POL",
        "currency": "pln",
        "name": "Poland",
        "number": "616"
    },
    "PM": {
        "alpha2": "PM",
        "alpha3": "SPM",
        "currency": "eur",
        "name": "Saint Pierre And Miquelon",
        "number": "666"
    },
    "PN": {
        "alpha2": "PN",
        "alpha3": "PCN",
        "currency": "nzd",
        "name": "Pitcairn",
        "number": "612"
    },
    "PR": {
        "alpha2": "PR",
        "alpha3": "PRI",
        "currency": "usd",
        "name": "Puerto Rico",
        "number": "630"
    },
    "PS": {
        "alpha2": "PS",
        "alpha3": "PSE",
        "currency": "ils",
        "name": "Palestine, State of",
        "number": "275"
    },
    "PT": {
        "alpha2": "PT",
        "alpha3": "PRT",
        "currency": "eur",
        "name": "Portugal",
        "number": "620"
    },
    "PW": {
        "alpha2": "PW",
        "alpha3": "PLW",
        "currency": "usd",
        "name": "Palau",
        "number": "585"
    },
    "PY": {
        "alpha2": "PY",
        "alpha3": "PRY",
        "currency": "pyg",
        "name": "Paraguay",
        "number": "600"
    },
    "QA": {
        "alpha2": "QA",
        "alpha3": "QAT",
        "currency": "qar",
        "name": "Qatar",
        "number": "634"
    },
    "RE": {
        "alpha2": "RE",
        "alpha3": "REU",
        "currency": "eur",
        "name": "Réunion",
        "number": "638"
    },
    "RO": {
        "alpha2": "RO",
        "alpha3": "ROU",
        "currency": "ron",
        "name": "Romania",
        "number": "642"
    },
    "RS": {
        "alpha2": "RS",
        "alpha3": "SRB",
        "currency": "rsd",
        "name": "Serbia",
        "number": "688"
    },
    "RU": {
        "alpha2": "RU",
        "alpha3": "RUS",
        "currency": "rub",
        "name": "Russian Federation",
        "number": "643"
    },
    "RW": {
        "alpha2": "RW",
        "alpha3": "RWA",
        "currency": "rwf",
        "name": "Rwanda",
        "number": "646"
    },
    "SA": {
        "alpha2": "SA",
        "alpha3": "SAU",
        "currency": "sar",
        "name": "Saudi Arabia",
        "number": "682"
    },
    "SB": {
        "alpha2": "SB",
        "alpha3": "SLB",
        "currency": "sbd",
        "name": "Solomon Islands",
        "number": "090"
    },
    "SC": {
        "alpha2": "SC",
        "alpha3": "SYC",
        "currency": "scr",
        "name": "Seychelles",
        "number": "690"
    },
    "SD": {
        "alpha2": "SD",
        "alpha3": "SDN",
        "currency": "sdg",
        "name": "Sudan",
        "number": "729"
    },
    "SE": {
        "alpha2": "SE",
        "alpha3": "SWE",
        "currency": "sek",
        "name": "Sweden",
        "number": "752"
    },
    "SG": {
        "alpha2": "SG",
        "alpha3": "SGP",
        "currency": "sgd",
        "name": "Singapore",
        "number": "702"
    },
    "SH": {
        "alpha2": "SH",
        "alpha3": "SHN",
        "currency": "shp",
        "name": "Saint Helena",
        "number": "654"
    },
    "SI": {
        "alpha2": "SI",
        "alpha3": "SVN",
        "currency": "eur",
        "name": "Slovenia",
        "number": "705"
    },
    "SJ": {
        "alpha2": "SJ",
        "alpha3": "SJM",
        "currency": "nok",
        "name": "Svalbard And Jan Mayen",
        "number": "744"
    },
    "SK": {
        "alpha2": "SK",
        "alpha3": "SVK",
        "currency": "eur",
        "name": "Slovakia",
        "number": "703"
    },
    "SL": {
        "alpha2": "SL",
        "alpha3": "SLE",
        "currency": "sll",
        "name": "Sierra Leone",
        "number": "694"
    },
    "SM": {
        "alpha2": "SM",
        "alpha3": "SMR",
        "currency": "eur",
        "name": "San Marino",
        "number": "674"
    },
    "SN": {
        "alpha2": "SN",
        "alpha3": "SEN",
        "currency": "xof",
        "name": "Senegal",
        "number": "686"
    },
    "SO": {
        "alpha2": "SO",
        "alpha3": "SOM",
        "currency": "sos",
        "name": "Somalia",
        "number": "706"
    },
    "SR": {
        "alpha2": "SR",
        "alpha3": "SUR",
        "currency": "srd",
        "name": "Suriname",
        "number": "740"
    },
    "SS": {
        "alpha2": "SS",
        "alpha3": "SSD",
        "currency": "ssp",
        "name": "South Sudan",
        "number": "728"
    },
    "ST": {
        "alpha2": "ST",
        "alpha3": "STP",
        "currency": "std",
        "name": "Sao Tome and Principe",
        "number": "678"
    },
    "SV": {
        "alpha2": "SV",
        "alpha3": "SLV",
        "currency": "usd",
        "name": "El Salvador",
        "number": "222"
    },
    "SX": {
        "alpha2": "SX",
        "alpha3": "SXM",
        "currency": "xcg",
        "name": "Sint Maarten",
        "number": "534"
    },
    "SY": {
        "alpha2": "SY",
        "alpha3": "SYR",
        "currency": "syp",
        "name": "Syrian Arab Republic",
        "number": "760"
    },
    "SZ": {
        "alpha2": "SZ",
        "alpha3": "SWZ",
        "currency": "szl",
        "name": "Swaziland",
        "number": "748"
    },
    "TC": {
        "alpha2": "TC",
        "alpha3": "TCA",
        "currency": "usd",
        "name": "Turks and Caicos Islands",
        "number": "796"
    },
    "TD": {
        "alpha2": "TD",
        "alpha3": "TCD",
        "currency": "xaf",
        "name": "Chad",
        "number": "148"
    },
    "TF": {
        "alpha2": "TF",
        "alpha3": "ATF",
        "currency": "eur",
        "name": "French Southern Territories",
        "number": "260"
    },
    "TG": {
        "alpha2": "TG",
        "alpha3": "TGO",
        "currency": "xof",
        "name": "Togo",
        "number": "768"
    },
    "TH": {
        "alpha2": "TH",
        "alpha3": "THA",
        "currency": "thb",
        "name": "Thailand",
        "number": "764"
    },
    "TJ": {
        "alpha2": "TJ",
        "alpha3": "TJK",
        "currency": "tjs",
        "name": "Tajikistan",
        "number": "762"
    },
    "TK": {
        "alpha2": "TK",
        "alpha3": "TKL",
        "currency": "nzd",
        "name": "Tokelau",
        "number": "772"
    },
    "TL": {
        "alpha2": "TL",
        "alpha3": "TLS",
        "currency": "idr",
        "name": "Timor-Leste",
        "number": "626"
    },
    "TM": {
        "alpha2": "TM",
        "alpha3": "TKM",
        "currency": "tmt",
        "name": "Turkmenistan",
        "number": "795"
    },
    "TN": {
        "alpha2": "TN",
        "alpha3": "TUN",
        "currency": "tnd",
        "name": "Tunisia",
        "number": "788"
    },
    "TO": {
        "alpha2": "TO",
        "alpha3": "TON",
        "currency": "top",
        "name": "Tonga",
        "number": "776"
    },
    "TR": {
        "alpha2": "TR",
        "alpha3": "TUR",
        "currency": "try",
        "name": "Turkey",
        "number": "792"
    },
    "TT": {
        "alpha2": "TT",
        "alpha3": "TTO",
        "currency": "ttd",
        "name": "Trinidad and Tobago",
        "number": "780"
    },
    "TV": {
        "alpha2": "TV",
        "alpha3": "TUV",
        "currency": "tvd",
        "name": "Tuvalu",
        "number": "798"
    },
    "TW": {
        "alpha2": "TW",
        "alpha3": "TWN",
        "currency": "twd",
        "name": "Taiwan",
        "number": "158"
    },
    "TZ": {
        "alpha2": "TZ",
        "alpha3": "TZA",
        "currency": "tzs",
        "name": "Tanzania, United Republic of",
        "number": "834"
    },
    "UA": {
        "alpha2": "UA",
        "alpha3": "UKR",
        "currency": "uah",
        "name": "Ukraine",
        "number": "804"
    },
    "UG": {
        "alpha2": "UG",
        "alpha3": "UGA",
        "currency": "ugx",
        "name": "Uganda",
        "number": "800"
    },
    "UM": {
        "alpha2": "UM",
        "alpha3": "UMI",
        "currency": "usd",
        "name": "United States Minor Outlying Islands",
        "number": "581"
    },
    "US": {
        "alpha2": "US",
        "alpha3": "USA",
        "currency": "usd",
        "name": "United States",
        "number": "840",
        "states": {
            "AA": {
                "name": "Armed Forces Americas"
            },
            "AE": {
                "name": "Armed Forces Europe"
            },
            "AK": {
                "name": "Alaska"
            },
            "AL": {
                "name": "Alabama"
            },
            "AP": {
                "name": "Armed Forces Pacific"
            },
            "AR": {
                "name": "Arkansas"
            },
            "AZ": {
                "name": "Arizona"
            },
            "CA": {
                "name": "California"
            },
            "CO": {
                "name": "Colorado"
            },
            "CT": {
                "name": "Connecticut"
            },
            "DC": {
                "name": "District of Columbia"
            },
            "DE": {
                "name": "Delaware"
            },
            "FL": {
                "name": "Florida"
            },
            "GA": {
                "name": "Georgia"
            },
            "HI": {
                "name": "Hawaii"
            },
            "IA": {
                "name": "Iowa"
            },
            "ID": {
                "name": "Idaho"
            },
            "IL": {
                "name": "Illinois"
            },
            "IN": {
                "name": "Indiana"
            },
            "KS": {
                "name": "Kansas"
            },
            "KY": {
                "name": "Kentucky"
            },
            "LA": {
                "name": "Louisiana"
            },
            "MA": {
                "name": "Massachusetts"
            },
            "MD": {
                "name": "Maryland"
            },
            "ME": {
                "name": "Maine"
            },
            "MI": {
                "name": "Michigan"
            },
            "MN": {
                "name": "Minnesota"
            },
            "MO": {
                "name": "Missouri"
            },
            "MS": {
                "name": "Mississippi"
            },
            "MT": {
                "name": "Montana"
            },
            "NC": {
                "name": "North Carolina"
            },
            "ND": {
                "name": "North Dakota"
            },
            "NE": {
                "name": "Nebraska"
            },
            "NH": {
                "name": "New Hampshire"
            },
            "NJ": {
                "name": "New Jersey"
            },
            "NM": {
                "name": "New Mexico"
            },
            "NV": {
                "name": "Nevada"
            },
            "NY": {
                "name": "New York"
            },
            "OH": {
                "name": "Ohio"
            },
            "OK": {
                "name": "Oklahoma"
            },
            "OR": {
                "name": "Oregon"
            },
            "PA": {
                "name": "Pennsylvania"
            },
            "PR": {
                "name": "Puerto Rico"
            },
            "RI": {
                "name": "Rhode Island"
            },
            "SC": {
                "name": "South Carolina"
            },
            "SD": {
                "name": "South Dakota"
            },
            "TN": {
                "name": "Tennessee"
            },
            "TX": {
                "name": "Texas"
            },
            "UT": {
                "name": "Utah"
            },
            "VA": {
                "name": "Virginia"
            },
            "VT": {
                "name": "Vermont"
            },
            "WA": {
                "name": "Washington"
            },
            "WI": {
                "name": "Wisconsin"
            },
            "WV": {
                "name": "West Virginia"
            },
            "WY": {
                "name": "Wyoming"
            }
        }
    },
    "UY": {
        "alpha2": "UY",
        "alpha3": "URY",
        "currency": "uyu",
        "name": "Uruguay",
        "number": "858"
    },
    "UZ": {
        "alpha2": "UZ",
        "alpha3": "UZB",
        "currency": "uzs",
        "name": "Uzbekistan",
        "number": "860"
    },
    "VA": {
        "alpha2": "VA",
        "alpha3": "VAT",
        "currency": "eur",
        "name": "Holy See (Vatican City State)",
        "number": "336"
    },
    "VC": {
        "alpha2": "VC",
        "alpha3": "VCT",
        "currency": "xcd",
        "name": "Saint Vincent And The Grenedines",
        "number": "670"
    },
    "VE": {
        "alpha2": "VE",
        "alpha3": "VEN",
        "currency": "vef",
        "name": "Venezuela, Bolivarian Republic of",
        "number": "862"
    },
    "VG": {
        "alpha2": "VG",
        "alpha3": "VGB",
        "currency": "usd",
        "name": "Virgin Islands, British",
        "number": "092"
    },
    "VI": {
        "alpha2": "VI",
        "alpha3": "VIR",
        "currency": "usd",
        "name": "Virgin Islands, U.S.",
        "number": "850"
    },
    "VN": {
        "alpha2": "VN",
        "alpha3": "VNM",
        "currency": "vnd",
        "name": "Vietnam",
        "number": "704"
    },
    "VU": {
        "alpha2": "VU",
        "alpha3": "VUT",
        "currency": "vuv",
        "name": "Vanuatu",
        "number": "548"
    },
    "WF": {
        "alpha2": "WF",
        "alpha3": "WLF",
        "currency": "xpf",
        "name": "Wallis and Futuna",
        "number": "876"
    },
    "WS": {
        "alpha2": "WS",
        "alpha3": "WSM",
        "currency": "usd",
        "name": "Samoa",
        "number": "882"
    },
    "YE": {
        "alpha2": "YE",
        "alpha3": "YEM",
        "currency": "yer",
        "name": "Yemen",
        "number": "887"
    },
    "YT": {
        "alpha2": "YT",
        "alpha3": "MYT",
        "currency": "eur",
        "name": "Mayotte",
        "number": "175"
    },
    "ZA": {
        "alpha2": "ZA",
        "alpha3": "ZAF",
        "currency": "zar",
        "name": "South Africa",
        "number": "710"
    },
    "ZM": {
        "alpha2": "ZM",
        "alpha3": "ZMB",
        "currency": "zmk",
        "name": "Zambia",
        "number": "894"
    },
    "ZW": {
        "alpha2": "ZW",
        "alpha3": "ZWE",
        "currency": "zwd",
        "name": "Zimbabwe",
        "number": "716"
    }
};
export default countries;

//# sourceMappingURL=index.js.map